import PathConstants from '../path-contants'

const getOnboardingPaths = (): PathConstants.RoutesProps => {
  return {
    ONBOADING: {
      value: '/onboarding',
      name: 'onbording'
    },
    ONBOADING_CHECK: {
      value: '/onboarding/check',
      name: 'onbording_check'
    },
    ONBOADING_1: {
      value: '/onboarding/1',
      name: 'onbording_1'
    },
    ONBOADING_2: {
      value: '/onboarding/2',
      name: 'onbording_2'
    },
    ONBOARDING_PERSONAL_DATA: {
      value: '/onboarding/personal-data',
      name: 'onbording_personal_data'
    },
    ONBOARDING_PROFESSIONAL_TRAJECTORY: {
      value: '/onboarding/professional-trajectory',
      name: 'professional_trajectory'
    },
    ONBOARDING_CAREER_MOMENT: {
      value: '/onboarding/career-moment',
      name: 'onbording_career_moment'
    },
    ONBOARDING_LEARNING_OBJECTIVES: {
      value: '/onboarding/learning-objectives',
      name: 'onbording_learning_objectives'
    },
    ONBOARDING_CONTENT_TYPES: {
      value: '/onboarding/content-types',
      name: 'onbording_content_types'
    },
    ONBOARDING_CONTENT_FORMATS: {
      value: '/onboarding/content-formats',
      name: 'onbording_content_formats'
    },
    ONBOADING_3: {
      value: '/onboarding/3',
      name: 'onbording_3'
    },
    ONBOADING_4: {
      value: '/onboarding/4',
      name: 'onbording_4'
    },
    ONBOADING_SECURITY: {
      value: '/onboarding/security',
      name: 'onbording_security'
    },
    ONBOADING_COMPLETED: {
      value: '/onboarding/completed',
      name: 'onbording_completed'
    }
  }
}

export default getOnboardingPaths
